// The module's own path and names. Routes, links and breadcrumbs read basePath
// from here rather than typing '/users' (checklist §1).
export default {
    entityKey: 'users',
    basePath: '/users',
    titles: {
        singular: 'User',
        plural: 'Users',
    },
};
